module.exports = __webpack_public_path__ + "assets/media/arrow-kazan.5bd6d820.svg";